import service from '@/utils/request';

// 教师端作业列表
export function getPage(data) {
  return service({
    url: '/v1/task/getPage',
    method: 'post',
    data
  })
}

// 获取用户字典信息
export function getPageDict(data) {
  return service({
    url: '/v1/systemDict/getPageDict',
    method: 'post',
    data
  })
}

// 获取用户字典类型信息
export function getPageDictType(data) {
  return service({
    url: '/v1/systemDict/getPageDictType',
    method: 'get',
    params: data
  })
}

// 保存
export function saveWork(data) {
  return service({
    url: '/v1/task/save',
    method: 'post',
    data
  })
}

// 更新
export function updateWork(data) {
  return service({
    url: '/v1/task/update',
    method: 'post',
    data
  })
}

// 根据id查询
export function getById(data) {
  return service({
    url: '/v1/task/getById',
    method: 'get',
    params: data
  })
}

// 班级作文已提交列表
export function getTaskUserList(data) {
  return service({
    url: '/v1/userTask/getTaskUserList',
    method: 'get',
    params: data
  })
}

// 一键审核
export function batchAudit(data) {
  return service({
    url: '/v1/userTask/batchAudit',
    method: 'get',
    params: data
  })
}

// 一键驳回
export function batchUnAudit(data) {
  return service({
    url: '/v1/userTask/batchUnAudit',
    method: 'get',
    params: data
  })
}

// 生成班级报告前的校验 返回0可以生成 返回1提示“当前还有人未进行作文提交，是否确定生成分析报告？”
export function checkTaskReport(data) {
  return service({
    url: '/v1/task/checkTaskReport',
    method: 'get',
    params: data
  })
}

// 开始生成班级报告
export function generateTaskReport(data) {
  return service({
    url: '/v1/task/generateTaskReport',
    method: 'get',
    params: data
  })
}


// 获取已经生成的班级报告
export function getTaskReport(data) {
  return service({
    url: '/v1/task/getTaskReport',
    method: 'get',
    params: data
  })
}

// 保存
export function userTaskSave(data) {
  return service({
    url: '/v1/userTask/save',
    method: 'post',
    data
  })
}

// 删除
export function userTaskDelete(data) {
  return service({
    url: '/v1/userTask/delete',
    method: 'delete',
    params: data
  })
}

// 删除
export function taskDelete(data) {
  return service({
    url: '/v1/task/delete',
    method: 'delete',
    params: data
  })
}

// 根据用户作业id获取分句点评
export function getByUserTaskId(data) {
  return service({
    url: '/v1/userTaskSentenceEvaluate/getByUserTaskId',
    method: 'get',
    params: data
  })
}
//根据用户作业id获取分句点评 1期
export function getByUserTaskId1(data) {
  return service({
    url: '/v1/essay/getEssaySsAssessByEssayId',
    method: 'post',
    data: data
  })
}

// 根据id查询
export function getUserTaskById(data) {
  return service({
    url: '/v1/userTask/getById',
    method: 'get',
    params: data
  })
}

// 综合点评结果
export function getCompAssessByUserTaskId(data) {
  return service({
    url: '/v1/userTaskCompAssess/getCompAssessByUserTaskId',
    method: 'get',
    params: data
  })
}


// 综合点评1期
export function getCompAssessByUserTaskId1(data) {
  return service({
    url: '/v1/essay/getCompAssessByEssayId',
    method: 'get',
    params: data
  })
}

// 获取分句点评对应的图片中的多边形数据
export function getEssaySSImageDetail(data) {
  return service({
    url: '/v1/essay/getClassEssaySSImageDetail',
    method: 'post',
    data
  })
}

// 更新
export function updateUserTaskSentenceEvaluate(data) {
  return service({
    url: '/v1/userTaskSentenceEvaluate/update',
    method: 'post',
    data
  })
}
// 更新 1期
export function updateUserTaskSentenceEvaluate1(data) {
  return service({
    url: '/v1/essay/updateSsAssess',
    method: 'post',
    data
  })
}

// 更新
export function updateUserTaskCompAssess(data) {
  return service({
    url: '/v1/userTaskCompAssess/update',
    method: 'post',
    data
  })
}



//更新点评 1期
export function updateUserTaskCompAssess1(data) {
  return service({
    url: '/v1/essay/updCompAssessById',
    method: 'post',
    data
  })
}

// 更新
export function updateUserTaskStyleEvaluate(data) {
  return service({
    url: '/v1/userTaskStyleEvaluate/update',
    method: 'post',
    data
  })
}

// 更新点评 1期
export function updateUserTaskStyleEvaluate1(data) {
  return service({
    url: '/v1/essay/updCompAssessStyleCommentById',
    method: 'post',
    data
  })
}

// 更新
export function updateUserTask(data) {
  return service({
    url: '/v1/userTask/update',
    method: 'post',
    data
  })
}

// 更新批改总分
export function updateUserTask1(data) {
  return service({
    url: '/v1/essay/updAssessById',
    method: 'post',
    data
  })
}

// 标记为范文
export function changeSampleStatus(data) {
  return service({
    url: '/v1/userTask/changeSampleStatus',
    method: 'get',
    params: data
  })
}

// 教师端列表
export function getUserTaskPage(data) {
  return service({
    url: '/v1/userTask/getPage',
    method: 'post',
    data
  })
}

// 审核
export function audit(data) {
  return service({
    url: '/v1/userTask/audit',
    method: 'get',
    params: data
  })
}

// pc端批量上传作文压缩包，第一步 返回合并后的学生作文列表
export function saveBatchConfirm(data) {
  return service({
    url: '/v1/userTask/saveBatchConfirm',
    method: 'post',
    data,
    headers:{
      'ContentType': 'application/json;charset=UTF-8',
    }
  })
}

// pc端批量上传作文第二步 返回成功人数
export function saveBatch(data) {
  return service({
    url: '/v1/userTask/saveBatch',
    method: 'post',
    data
  })
}

// 驳回
export function unAudit(data) {
  return service({
    url: '/v1/userTask/unAudit',
    method: 'get',
    params: data
  })
}

// 初始化默认配置
export function getSetting(data) {
  return service({
    url: '/v1/task/getSettingsByTaskId',
    method: 'get',
    params: data
  })
}

// 导出之前，用户选择的选项  1期 
export function getSetting1(data) {
  return service({
    url: '/v1/essay/exportOptions',
    method: 'post',
    data: data
  })
}

// 更新用户配置信息
export function updateSetting(data) {
  return service({
    url: '/v1/task/updateSettingsByTaskId',
    method: 'post',
    data
  })
}

// 进入班级作文页之后先调用，判断是显示“生成报告”还是“查看报告”按钮，返回0生成报告 2查看报告
export function checkTaskReportExist(data) {
  return service({
    url: '/v1/task/checkTaskReportExist',
    method: 'get',
    params: data
  })
}

// 教师重新提交所有因为ai豆不足而没有批改的学生作文
export function resubmitInsufficientAiBean(data) {
  return service({
    url: '/v1/userTask/resubmitInsufficientAiBean',
    method: 'get',
    params: data
  })
}

// 导出一个学生作文报告,pdf和word都用这个接口
export function exportOneStudent(data) {
  return service({
    url: '/v1/userTask/exportOneStudent',
    method: 'post',
    data
  })
}

//导出作文,批改,润色等 1期
export function exportOneStudent1(data) {
  return service({
    url: '/v1/essay/export',
    method: 'post',
    data
  })
}

// 根据作文id导出班级内所有可生成报告的学生报告的PDF，返回ZIP压缩包文件地址
export function exportReportPDFClassStudentZIP(data) {
  return service({
    url: '/v1/userTask/exportReportPDFClassStudentZIP',
    method: 'post',
    data
  })
}

// 查询报告PDF压缩包生成进度
export function getPDFZipProgress(data) {
  return service({
    url: '/v1/userTask/getPDFZipProgress',
    method: 'get',
    params: data
  })
}

// 提取图片中的文字
export function extractImageTextByOCR (data) {
  return service({
    url: '/v1/userTask/extractImageTextByOCROnly',
    method: 'post',
    data
  })
}